import { parseNumber, transformModel } from '~/src/dash/api/resource-transforms';
import { addDomainAndTokenToUrl, IHttpResponse, restGet } from '~/src/dash/api/rest';

export interface IDOOHVenueMultiplierMapPair {
  ID: number;
  CreatedAt?: string;
  UpdatedAt?: string;
  DeletedAt?: string;

  MultiplierAmount: number;
  PublisherID: number;
  VenueID: string;
  VenueLatitude: number;
  VenueLongitude: number;
}

export const transformDOOHVenueMultiplierMapPair = transformModel<IDOOHVenueMultiplierMapPair>({
  ID: parseNumber(['ID']),
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  DeletedAt: 'DeletedAt',

  MultiplierAmount: 'MultiplierAmount',
  PublisherID: 'PublisherID',
  VenueID: 'VenueID',
  VenueLatitude: 'VenueLatitude',
  VenueLongitude: 'VenueLongitude',
});

// GET all DOOHVenueMultiplierMapPairs for this publisher
// /publishers/{publisherID}/dooh_venue_multiplier_map_pairs
export async function getDOOHVenueMultiplierMapPairs(
  publisherID: string,
): Promise<IDOOHVenueMultiplierMapPair[]> {
  const reqUrl = addDomainAndTokenToUrl(
    `/publishers/${publisherID}/dooh_venue_multiplier_map_pairs`,
  );
  return await restGet<IDOOHVenueMultiplierMapPair[]>(reqUrl, {}).then(
    (val: IHttpResponse<IDOOHVenueMultiplierMapPair[]>) => {
      return val.parsedBody ? val.parsedBody.map(transformDOOHVenueMultiplierMapPair) : [];
    },
  );
}
